module.exports = __webpack_public_path__ + "img/94.9ed696b5.jpg";